import { render, staticRenderFns } from "./buyOrderPop.vue?vue&type=template&id=2cc8fa28&scoped=true&"
import script from "./buyOrderPop.vue?vue&type=script&lang=js&"
export * from "./buyOrderPop.vue?vue&type=script&lang=js&"
import style0 from "./buyOrderPop.vue?vue&type=style&index=0&id=2cc8fa28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8fa28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc8fa28')) {
      api.createRecord('2cc8fa28', component.options)
    } else {
      api.reload('2cc8fa28', component.options)
    }
    module.hot.accept("./buyOrderPop.vue?vue&type=template&id=2cc8fa28&scoped=true&", function () {
      api.rerender('2cc8fa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseOrder/components/buyOrderPop.vue"
export default component.exports